// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"60cd818a","236":"79db1eaa","703":"6e35d905","787":"687ab8c0"}[chunkId] + ".chunk.js";
};